export default "__VITE_ASSET__CtAelqDo__"